<template>
  <section class="section">
    <div class="container">
      <div class="row">
        <div class="form-group">
          <button class="btn btn-fill" @click.prevent="clickNew">Nueva</button>
        </div>
      </div>
      <div class="row" v-if="mostrarForm">
        <div class="form-group">
          <label for="">Nombre</label>
          <input type="text" v-model="formData.nombre" class="form-control">
          <span class="label label-danger" v-if="!$v.formData.nombre.required && mostrarErrores">El nombre es requerido</span>
        </div>
        <div class="form-group">
          <label for="">Descripción</label>
          <textarea v-model="formData.descripcion" id="" rows="10" class="form-control"></textarea>
        </div>
        <div class="form-group">
          <div class="text-center center-block">
            <button @click.prevent="guardar" class="btn btn-fill">Guardar</button>
          </div>
        </div>
      </div>
      <div class="row">
        <table class="table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Notificar por Whatsapp</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="categoria in categorias">
              <td>{{categoria.nombre}}</td>
              <td>{{categoria.descripcion}}</td>
              <td>
                <span class="clickeable text-success" v-if="categoria.notificarWhatsapp" @click.prevent="toggleFalse(categoria)"><i class="fa fa-whatsapp"></i> Incluido en notificaciones</span>
                <span class="clickeable text-danger" v-if="!categoria.notificarWhatsapp" @click.prevent="toggleTrue(categoria)"><i class="fa fa-times"></i> No se notifica</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>
<script>
  import {required} from 'vuelidate/lib/validators'
  export default {
    data () {
      return {
        categorias: [],
        mostrarErrores: false,
        mostrarForm: false,
        formData: {
          nombre: '',
          descripcion: '',
          notificarWhatsapp: false,
          _id: null
        }
      }
    },
    validations: {
      formData: {
        nombre: {
          required
        }
      }
    },
    mounted () {
      this.reload()
    },
    methods: {
      reload () {
        const me = this
        me.$http.get('/api/admin/categorias').then(({body}) => {
          me.categorias = body
          console.log(body)
        }, (err) => {
          console.error(err)
        })
      },
      toggleTrue (categoria) {
        const me = this
        categoria.notificarWhatsapp = true
        me.$http.post('/api/admin/categorias/whatsapp', categoria).then(({body}) => {
          me.$emit('mostrar-notificacion', 'La categoria se guardó correctamente', 'success')
          me.reload()
        }, (err) => {
          console.error(err)
        })
      },
      toggleFalse (categoria) {
        categoria.notificarWhatsapp = false
        const me = this
        me.$http.post('/api/admin/categorias/whatsapp', categoria).then(({body}) => {
          me.$emit('mostrar-notificacion', 'La categoria se guardó correctamente', 'success')
          me.reload()
        }, (err) => {
          console.error(err)
        })
      },
      clearForm () {
        const me = this
        me.formData.nombre = ''
        me.formData.descripcion = ''
        me.formData.notificarWhatsapp = ''
        me.formData._id = null
      },
      clickNew () {
        const me = this
        me.clearForm()
        me.mostrarForm = true
      },
      guardar () {
        const me = this
        me.mostrarErrores = false
        if (me.$v.formData.$invalid) {
          me.mostrarErrores = true
          return false
        }
        me.$http.post('/api/admin/categorias', me.formData).then(({body}) => {
          me.categorias.push(body)
          me.$emit('mostrar-notificacion', 'La categoria se guardó correctamente', 'success')
          me.clearForm()
          me.mostrarForm = false
        }, (err) => {
          console.error(err)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Lista.vue?9000e11e